import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const track = async () => {
      try {
        await (supabase as any).from("page_views").insert({
          page_path: location.pathname,
          referrer: document.referrer || null,
          user_agent: navigator.userAgent || null,
        });
      } catch {
        // Silent fail — analytics should never break the app
      }
    };
    track();
  }, [location.pathname]);
}
